<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{$t('system.text_141', [$t('dictionary.notice')])}}</div>
    <div slot="body">
      <dialog-table :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form
        :form="form.fc"
        v-bind="formItemLayout">
        <a-form-item v-show="isAdminMode" :label="$t('system.announcement.scope')">
          <a-radio-group v-decorator="decorators.set_system" button-style="solid" disabled>
            <a-radio-button :value="true">
              {{ $t('cloudenv.text_504')}}
            </a-radio-button>
            <a-radio-button :value="false">
              {{ $t('dictionary.domain')}}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="$t('system.text_307')">
          <a-input v-decorator="decorators.title" :placeholder="$t('system.text_310')" />
        </a-form-item>
        <a-form-item :label="$t('system.text_308')">
          <a-input v-decorator="decorators.content" type="textarea" :rows="4" :placeholder="$t('system.text_311')" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import * as R from 'ramda'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'NoticeUpdateDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      isAdminMode: this.$store.getters.isAdminMode,
      form: {
        fc: this.$form.createForm(this),
      },
      decorators: {
        set_system: [
          'set_system',
          {
            initialValue: this.params.data[0].visible_scope ? this.params.data[0].visible_scope === 'system' : this.$store.getters.isAdminMode,
            rules: [
              {
                required: true,
                message: this.$t('system.announcement.scope.tips'),
              },
            ],
          },
        ],
        title: [
          'title',
          {
            initialValue: this.params.data[0].title,
            validateFirst: true,
            rules: [
              {
                required: true,
                message: this.$t('system.text_312'),
                transform: val => val && R.trim(val),
              },
              {
                min: 2,
                max: 24,
                message: this.$t('system.text_313'),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
        content: [
          'content',
          {
            initialValue: this.params.data[0].content,
            validateFirst: true,
            rules: [
              {
                required: true,
                message: this.$t('system.text_139'),
                transform: val => val && R.trim(val),
              },
              {
                min: 1,
                max: 140,
                message: this.$t('system.text_314'),
                transform: val => val && R.trim(val),
              },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 18,
        },
        labelCol: {
          span: 6,
        },
      },
    }
  },
  destroyed () {
    this.manager = null
  },
  created () {
    this.manager = new this.$Manager('notices', 'v1')
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        await this.manager.batchUpdate({
          ids: this.params.data.map(item => item.id),
          data: values,
        })
        this.loading = false
        this.params.success()
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
